import { createSlice } from "@reduxjs/toolkit";

export const blogLangMapImages = createSlice({
  name: "blog_lang_map_images",
  initialState: {
    value: { status: false, data: [] },
  },
  reducers: {
    updateBlogLangMapImages: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateBlogLangMapImages } = blogLangMapImages.actions;

export default blogLangMapImages.reducer;
